<template>
    <span class="inline-flex items-center gap-2 whitespace-nowrap">
        <span   class="rounded-full px-2 py-0.5 text-xs font-medium text-white"
                :class="colour"
        >{{ label }}</span>

        <span   v-if="interval === 'weekly'"
                class="text-sm text-gray-700"
        >({{ weekdayName }})</span>
    </span>
</template>

<script>
import {Intervals} from "../Intervals"

const COLOURS = {
    daily: 'bg-gray-500',
    'daily-data': 'bg-gray-500',
    weekly: 'bg-green-500',
    'semi-monthly': 'bg-amber-500',
    monthly: 'bg-blue-600',
}

const LABELS = {
    daily: 'Daily',
    'daily-data': "Daily (Day's Data)",
    weekly: 'Weekly',
    'semi-monthly': 'Semi-Monthly',
    monthly: 'Monthly',
}

// A weekly report saved without a day is sent on Monday (BaseReport default).
const DEFAULT_WEEKDAY = 1

export default {
    name: "FrequencyBadge",
    props: {
        interval: {
            type: String,
            required: true,
        },
        weekday: {
            type: [Number, String],
            default: null,
        },
    },
    computed: {
        colour() {
            return COLOURS[this.interval] ?? 'bg-gray-500'
        },
        label() {
            return LABELS[this.interval] ?? this.interval
        },
        weekdayName() {
            return Intervals.WEEKDAY_OPTIONS[this.weekday ?? DEFAULT_WEEKDAY] ?? Intervals.WEEKDAY_OPTIONS[DEFAULT_WEEKDAY]
        },
    },
}
</script>
